import React from 'react'
import { makeStyles } from '@mui/styles'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import Footer from './mainFooter'

const useStyles = makeStyles(theme => ({
  header: {
    width: '100%',
    padding: '0 50px',
    [theme.devices.mobile]: {
      padding: '0 20px',
    },
  },
  main: (props) => ({
    display: props.finishView ? 'block' : 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
    width: props.width || 570,
    overflow: 'hidden',
    '@media (max-width: 800px)': {
      width: '100%',
      display: 'flex',
    },
  }),
  container: (props) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexGrow: 1,
    width: '100%',
    maxWidth: 570,
    position: 'unset',
    padding: '0px 20px 0px 20px',
    '@media (min-width: 800px)': {
      position: 'initial',
      maxWidth: 'unset',
      padding: '0px 24px 0 24px',
    },
    [theme.devices.mobile]: {
      paddingBottom: props.stickyBottomForMobile ? '20vh' : 0,
    },
  }),
  title: {
    color: theme.horizontalRule.color,
    fontSize: theme.fontSizes.xlarge,
    lineHeight: '34px',
    letterSpacing: 0.48,
    marginTop: 0,
    marginBottom: 15,
    textAlign: 'center',
    '@media (min-width: 800px)': {
      fontSize: theme.fontSizes.xlarge,
      lineHeight: '26px',
      letterSpacing: 0.24,
    },

    [theme.devices.mobile]: {
      margin: 20,
    },
  },
  text: {
    textAlign: 'center',
    fontSize: theme.fontSizes.default,
    lineHeight: '26px',
    letterSpacing: 0.32,
    marginBottom: 40,
    marginTop: 0,
    '@media (min-width: 800px)': {
      fontSize: theme.fontSizes.default,
      letterSpacing: 0.14,
    },
  },
  textAvv: {
    textAlign: 'center',
    fontSize: theme.fontSizes.default,
    lineHeight: '26px',
    letterSpacing: 0.32,
    marginBottom: 30,
    marginTop: 0,
    paddingRight: 35,
    paddingLeft: 35,
    '@media (min-width: 800px)': {
      fontSize: theme.fontSizes.default,
      letterSpacing: 0.14,
    },

    [theme.devices.mobile]: {
      margin: 0,
      marginBottom: 20,
      padding: 0,
    },
  },
  description: {
    textAlign: 'center',
    fontSize: theme.fontSizes.default,
    lineHeight: '26px',
    letterSpacing: 0.32,
    marginTop: -35,
    '@media (min-width: 800px)': {
      fontSize: theme.fontSizes.default,
      letterSpacing: 0.14,
    },

    [theme.devices.mobile]: {
      margin: '0 48px',
    },
  },
  indicators: {
    marginBottom: 20,
    textAlign: 'center',
  },
  indicator: ({ active }) => ({
    display: 'inline-block',
    width: 12,
    height: 12,
    border: `1px solid ${active ? theme.primary : theme.borderColor}`,
    background: active ? theme.primary : theme.white,
    borderRadius: '50%',
    margin: '0 3px',
  }),
}))

const MainWrapper = ({ title, text, description, children, disabled, onNextButtonClick, onSkipButtonClick, skippable, width, finishView, isMboOnboarding, stickyBottomForMobile = false }) => {
  const classes = useStyles({ width, finishView, stickyBottomForMobile })
  const { step, totalSteps } = useSelector(state => state.wizard.config)
  const isMeinbuero = ENV.product === 'meinbuero'

  const Indicator = ({ active }) => {
    const classes = useStyles({ active })

    return (
      <span className={classes.indicator} />
    )
  }

  return (
    <>
      <div className={classes.header}>
        <p className={classes.title}>{title}</p>
        {text && <p className={isMboOnboarding ? classes.textAvv : classes.text} dangerouslySetInnerHTML={{ __html: text }} />}
        {description && <p className={classes.description} dangerouslySetInnerHTML={{ __html: description }} />}
      </div>
      <div className={classes.main}>
        <div className={classes.container}>
          {children}
        </div>
        {
          isMeinbuero
            ? (
              <div>
                <div className={classes.indicators}>
                  { totalSteps > 1 && [...Array(totalSteps)?.fill(undefined)]?.map((useless, index) => <Indicator key={`indicator_${index}`} active={index === step} />)}
                </div>
              </div>
            )
            : null
        }
        <Footer
          isMboOnboarding={isMboOnboarding}
          skippable={skippable}
          disabled={disabled}
          onNextButtonClick={onNextButtonClick}
          onSkipButtonClick={onSkipButtonClick}
          stickyBottomForMobile={stickyBottomForMobile}
        />
      </div>

    </>
  )
}

MainWrapper.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  onNextButtonClick: PropTypes.func,
  onSkipButtonClick: PropTypes.func,
  skippable: PropTypes.bool,
  width: PropTypes.number,
  finishView: PropTypes.bool,
  isMboOnboarding: PropTypes.bool,
  stickyBottomForMobile: PropTypes.bool,
}

MainWrapper.defaultProps = {
  disabled: false,
  skippable: false,
  finishView: false,
  stickyBottomForMobile: false,
}

export default MainWrapper
